import { router } from '@routes/router';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { initMixpanel } from '@utils/mixpanel';
import { initSentry } from '@utils/sentry';

if (import.meta.env.MODE === 'production') {
  initSentry();
  initMixpanel();
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
